import { render, staticRenderFns } from "./LkAdmin.vue?vue&type=template&id=064ce800&"
import script from "./LkAdmin.vue?vue&type=script&lang=js&"
export * from "./LkAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LkAdmin.vue?vue&type=style&index=0&id=064ce800&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports